module.exports = __webpack_public_path__ + "media/react/assets/images/dinareading-c18d96b22e0efa3186e39ba9acacee53.png";